<template>
    <main-content>
        <user-limited-filter :action="applyFilter"></user-limited-filter>
        <kt-datatable v-bind="datatableProps" ref="datatable">
        </kt-datatable>
    </main-content>
</template>

<script>
import MainContent from "@/components/main-content.vue";
import { ApiUrl } from "@/common/api.service";
import { AuthorizationHeader } from "@/common/jwt.service";
import userLimitedColumn from "@/views/user/datatable/userLimitedColumn";
import UserLimitedFilter from "@/views/user/components/user-limited-filter.vue";

export default {
    name: "UserLimited",
    components: { UserLimitedFilter, MainContent },
    data() {
        return {
            query: {},
        }
    },
    computed: {
        datatableProps() {
            return {
                id: 'fraud-event',
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('users/limited'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        },

                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                pagination: false,
                sortable: true,
                columns: userLimitedColumn
            }
        },
    },


    methods: {
        applyFilter(e, query) {
            this.query = query;
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },

        reloadDatatable() {
            if (this.$refs.datatable) {
                this.$refs.datatable.reload();
            }
        },
    }
}
</script>

<style scoped></style>